import markersGetter from '@/services/general/map/markersGetter';
import { COULEUR_PUCE_DEFAULT } from '@/configuration/general/carteConf';

export default function getInformationMarkers(affectation, produit, markers, color) {
  if (!produit || !produit.adresse || !produit.adresse.latitude || !produit.adresse.longitude) {
    return;
  }
  const latitude = Number(produit.adresse.latitude);
  const longitude = Number(produit.adresse.longitude);
  if (markers.find((m) => {
    return m.position.lat === latitude && m.position.lng === longitude;
  })) return;
  markersGetter(
    produit.adresse, color || COULEUR_PUCE_DEFAULT, produit.azimut, markers,
  );
}
